import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  count: number;
  noun: string;
  showAutoApproved: boolean;
}

export default function HiddenApprovedFooter({ count, noun, showAutoApproved }: Props) {
  if (showAutoApproved || count === 0) {
    return null;
  }

  return (
    <Box sx={{ bgcolor: 'grey.50', borderTop: 1, borderColor: 'divider', color: 'text.secondary', px: 2, py: 1.25 }}>
      <Typography variant="caption">
        {count} approved {noun}
        {count === 1 ? '' : 's'} hidden. Click <strong>Show approved</strong> to expand the report.
      </Typography>
    </Box>
  );
}
